export default function createMailtoLink(emailAddress: string, subject?: string): string {
  let result = `mailto:${emailAddress}`;
  if (subject) {
    result += `?subject=${encodeURIComponent(subject)}`;
  }
  return result;
}
